import { Component,  Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { forwardRef } from "@angular/core";
// import * as str from 'string';
import * as he from 'he';
import * as striptags from 'striptags';

export const IOSEDITOR_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => IosEditor),
  multi: true
};
@Component({
  selector: 'ios-editor',
  template: `<textarea [style.height.px]="height" 
                       [(ngModel)]="plainValue" 
                       (ngModelChange)="onChange()"
                       (blur)="onBlur()"></textarea>`,
  providers: [IOSEDITOR_VALUE_ACCESSOR]
})
export class IosEditor implements  ControlValueAccessor {

  //Placeholders for the callbacks which are later providesd
  //by the Control Value Accessor
  private onTouchedCallback: () => void;
  private onChangeCallback: (_: any) => void;

  @Input() height: number = 200;

  plainValue = '';


  onChange() {
    const htmlValue = this.plainToHtml(this.plainValue);
    if(this.onChangeCallback) this.onChangeCallback(htmlValue);
  }

  onBlur(){
    if(this.onTouchedCallback) this.onTouchedCallback();
  }


  //From ControlValueAccessor interface
  writeValue(value: string) {
    if(typeof value !== 'string') value = '';

    this.plainValue = this.htmlToPlain(value);
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  private htmlToPlain(value) {
    let decoded = value
      .replace(new RegExp("\n", 'g'), "")
      .replace(new RegExp('<br>', 'g'), "\n")
      .replace(new RegExp('<br />', 'g'), "\n")
      .replace(new RegExp('</p>', 'g'), "\n");
    decoded = he.decode(decoded);
    decoded = striptags(decoded);

    // console.log(['htmlToPlain',value, decoded]);
    return decoded;
  }

  private plainToHtml(value) {
      if (typeof value === 'undefined' || value === null) {
          return '';
      }
      const breakTag = '<br>';
      return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }


}



// WEBPACK FOOTER //
// ./src/partials/ios-editor/ios-editor.ts